import React from 'react'
import { Label, Paragraph, TxtLink } from 'atoms/Texts'
import { notifRouteHelper } from 'helpers/notifNavigateHelper'
import { withTheme } from 'styled-components'
import { withRouter } from 'react-router-dom'

const ToastItem = ({ notification, data, theme, history: { push } }) => {
  const { title, body } = notification;
  const { payload, type } = data;
  const { id: itemId } = JSON.parse(payload)
  const fullRoute = notifRouteHelper(type, itemId)

  return (
    <div>
      <Label color={theme.mocaOrange}>
        {title}
      </Label>
      <Paragraph>
        {body}
      </Paragraph>
      <TxtLink href={'#'} onClick={() => push(fullRoute)}>
        Show Detail
      </TxtLink>
    </div>
  )
}

export default withRouter(
  withTheme(ToastItem)
)
